import {
  STEPPER_GLOBAL_OPTIONS,
  StepperSelectionEvent
} from '@angular/cdk/stepper';
import {
  ChangeDetectionStrategy,
  Component,
  output,
  viewChild
} from '@angular/core';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { filter, tap, throttleTime } from 'rxjs';

import { OnboardingSignUpStepState } from '~core/models/shared.models';
import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'onboarding-stepper',
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ],
  standalone: false,
  templateUrl: './onboarding-stepper.component.html',
  styleUrl: './onboarding-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingStepperComponent extends BaseAuthComponent {
  private readonly _stepper = viewChild.required(MatStepper);

  states: OnboardingSignUpStepState[] = [];
  stepChange = output<number>();

  emitStepChange(step: StepperSelectionEvent): void {
    this._updateStates(step.selectedIndex);
    this.stepChange.emit(step.selectedIndex);
    this._eventService.emit({
      type: 'ONBOARDING_STEP_CHANGED',
      value: step.selectedIndex
    });
  }

  onStepNext$ = this._eventService.events$.pipe(
    throttleTime(500),
    filter(event => event.type === 'GO_TO_NEXT_STEP'),
    tap({
      next: () => {
        this._goToStep((this._stepper().selectedIndex || 0) + 1);
      }
    })
  );

  onStepPrevious$ = this._eventService.events$.pipe(
    filter(event => event.type === 'GO_TO_PREVIOUS_STEP'),
    tap({
      next: event => {
        this._goToStep(
          typeof event.value === 'number'
            ? event.value
            : (this._stepper().selectedIndex || 0) - 1
        );
      }
    })
  );

  private _goToStep(stepIndex: number): void {
    const stepper = this._stepper();
    stepper.linear = false;
    stepper.selectedIndex = stepIndex;
    this._updateStates(stepIndex);
    this._eventService.emit({
      type: 'ONBOARDING_STEP_CHANGED',
      value: stepIndex
    });
    this._cdRef.detectChanges();

    setTimeout(() => {
      stepper.linear = true;
    });
  }

  private _updateStates(activeIndex: number): void {
    const stepper = this._stepper();
    for (let i = 0; i < this.states.length; i++) {
      this.states[i] =
        i < activeIndex ? 'done' : i === activeIndex ? 'edit' : 'number';
    }

    stepper.steps.forEach((step: MatStep, i: number) => {
      if (i > activeIndex) step.completed = false;
    });

    this._cdRef.markForCheck();
  }
}
